/**
 * horn兜底配置
 */
export const dcepCommonConfig = {
  bulletin: {
    isShow: true,
    whiteApply: {
      text: '如您操作中遇到异常问题，请拨打美团客服电话：95172-5-5'
    },
    reward: {
      text: '目前活动参与人数较多，红包预计至多1个工作日到账，如有问题请拨打美团客服电话：95172-5-5'
    },
    divide: {
      text: '目前活动参与人数较多，红包预计至多1个工作日到账，如有问题请拨打美团客服电话：95172-5-5'
    }
  },
  announcement: {
    isShow: true,
    content: '由于系统维护，9月12日凌晨1:00-3:00暂停服务 >',
    link: 'https://i.meituan.com/awp/hfe/block/c0160650bded/140024/index.html'
  },
  bankMap: {
    403: {
      name: '中国邮政储蓄银行',
      logos: 'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/youzheng_logo.png'
    },
    404: {
      name: '中国农业银行',
      logos: 'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/nongye_logo.png'
    },
    405: {
      name: '中国建设银行',
      logos: 'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/jianshe_logo.png'
    }
  },
  downloadUrl: {
    androidUrl: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/20211107/pboc.apk'
  },
  guideSteps: {
    fiveSteps: [
      {
        title: '领取红包'
      },
      {
        title: '下载数币App',
        order: 1
      },
      {
        title: '开通钱包',
        order: 2
      },
      {
        title: '推送子钱包',
        order: 3
      },
      {
        title: '瓜分奖池',
        bubble: 'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/step-buble.png'
      }
    ],
    fourSteps: [
      {
        title: '领取红包'
      },
      {
        title: '下载数币App',
        order: 1
      },
      {
        title: '推送子钱包',
        order: 2
      },
      {
        title: '瓜分奖池',
        bubble: 'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/step-buble.png'
      }
    ],
    isCombine: false
  }
};
